import { Icon, Stack } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";
import { Amenity } from "@graphql";
import { amenities } from "../../filters/Filters";

interface Props {
  spaceProperties: Amenity[];
}

const Amenities: FunctionComponent<Props> = (props: Props) => {
  const { spaceProperties } = props;
  return (
    <Stack tokens={{ childrenGap: 10 }}>
      {spaceProperties &&
        spaceProperties.map((ra, index) => {
          const amenity = amenities.filter((a) => a.key == ra.name)[0];
          return (
            <div key={`amenties-${index}`} style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <Icon iconName="BoxCheckmarkSolid" />
              </div>
              <div style={{ flex: 1 }}>
                <span className="material-symbols-outlined">{ra.icon[0].toUpperCase() + ra.icon.slice(1)}</span>
              </div>
              <div style={{ flex: 8 }}>{amenity?.text || ra.name}</div>
            </div>
          );
        })}
    </Stack>
  );
};

export default Amenities;
